import { render, staticRenderFns } from "./SurveysList.vue?vue&type=template&id=597246a2&scoped=true&"
import script from "./SurveysList.vue?vue&type=script&lang=js&"
export * from "./SurveysList.vue?vue&type=script&lang=js&"
import style0 from "./SurveysList.vue?vue&type=style&index=0&id=597246a2&lang=scss&scoped=true&"
import style1 from "./SurveysList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597246a2",
  null
  
)

export default component.exports